module.exports = __webpack_public_path__ + "static/media/sucess.a44aeb60.svg";